import { authFetch } from "./api";
import type { PersonaRuoloCompany } from "./company";

export async function getRoles() {
  try {
    const url = `${import.meta.env.VITE_API_URL}/people/me/role`;
    const response = await authFetch(url)
    const json = await response.json();
    if(!response.ok) {
      return {data: null, error: json.message || "Errore sconosciuto"};
    }

    return {data: json as Roles, error: null};

  } catch (error) {
    return {data: null, error: error instanceof Error ? error.message : "Errore sconosciuto"};
  }
}

export async function getPeople() {
  try {
    const url = `${import.meta.env.VITE_API_URL}/people/hierarchy`;
    const response = await authFetch(url)
    const json = await response.json();
    if(!response.ok) {
      return {data: null, error: json.message || "Errore sconosciuto"};
    }

    return {data: json as Person[], error: null};

  } catch (error) {
    return {data: null, error: error instanceof Error ? error.message : "Errore sconosciuto"};
  }
}

export async function getPerson(email: string) {
  try {
    const url = `${import.meta.env.VITE_API_URL}/people/${email}`;
    const response = await authFetch(url)
    const json = await response.json();
    if(!response.ok) {
      return {data: null, error: json.message || "Errore sconosciuto"};
    }

    return {data: json as Person, error: null};

  } catch (error) {
    return {data: null, error: error instanceof Error ? error.message : "Errore sconosciuto"};
  }
}


export async function patchPerson(email: string, data: Partial<Person>) {
  try {
    const url = `${import.meta.env.VITE_API_URL}/people/${email}`;
    const response = await authFetch(url, {
      method: "PATCH",
      body: JSON.stringify(data)
    });
    if(!response.ok) {
      return {data: null, error:response.statusText|| "Errore sconosciuto"};
    }

    return {error: null};

  } catch (error) {
    return { error: error instanceof Error ? error.message : "Errore sconosciuto"};
  }
} 


export async function postPerson(data: Person) {
  try {
    const url = `${import.meta.env.VITE_API_URL}/people`;
    const response = await authFetch(url, {
      method: "POST",
      body: JSON.stringify(data)
    });
    if(!response.ok) {
      return {data: null, error:response.statusText|| "Errore sconosciuto"};
    }

    return {error: null};

  } catch (error) {
    return { error: error instanceof Error ? error.message : "Errore sconosciuto"};
  }
} 

export async function getRolesList() {
  try {
    const url = `${import.meta.env.VITE_API_URL}/people/roles`;
    const response = await authFetch(url)
    const json = await response.json();
    if(!response.ok) {
      return {data: null, error: json.message || "Errore sconosciuto"};
    }

    return {data: json , error: null};

  } catch (error) {
    return {data: null, error: error instanceof Error ? error.message : "Errore sconosciuto"};
  }
}

export async function addRole(prc: PersonaRuoloCompany) {
  try {
    const url = `${import.meta.env.VITE_API_URL}/people/roles`;
    const response = await authFetch(url, {
      method: "POST",
      body: JSON.stringify(prc)
    });
    if(!response.ok) {
      return {error:response.statusText|| "Errore sconosciuto"};
    }

    return {error: null};

  } catch (error) {
    return { error: error instanceof Error ? error.message : "Errore sconosciuto"};
  }
}

export async function deleteRole(prc: PersonaRuoloCompany) {
  try {
    const url = `${import.meta.env.VITE_API_URL}/people/roles`;
    const response = await authFetch(url, {
      method: "DELETE",
      body: JSON.stringify(prc)
    });
    if(!response.ok) {
      return { error:response.statusText|| "Errore sconosciuto"};
    }

    return {error: null};

  } catch (error) {
    return { error: error instanceof Error ? error.message : "Errore sconosciuto"};
  }
}

export type Roles = {
  isOperator: boolean;
  isPm: boolean;
  isClevel: boolean;
  isAdmin: boolean;
}

export type Person = {
  name: string;
  email: string;
  managerEmail: string | null
  isClevel: boolean;
  isAdmin: boolean;
  roles?: PersonaRuoloCompanyDTO[]
}

export type PersonaRuoloCompanyDTO = {
  companyId: string;
  sapCode: string;
  role: string;
  legalEntity: string;
}
